import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Atoms/Alerts/BulletinAlert.js");
;
import(/* webpackMode: "eager", webpackExports: ["TealButton"] */ "/Users/ilias/Github/talnet.co/src/components/Atoms/Buttons/ColorButtons.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ilias/Github/talnet.co/src/components/Atoms/FormElements/SearchForm.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ilias/Github/talnet.co/src/components/Organisms/Nav/Sidebar.js");
